/** @format */

function HeaderBlock() {
  return (
    <header className="App-header">
      <h1>Life in weeks</h1>
      <p>
        We've all heard life is short. But do we have any idea really how short
        is it?
      </p>
      <p>
        Each square represents a week in your life, A row of 52 weeks is an year
        in your life.
      </p>
      <p>Fill in the data below and see your life calendar.</p>
    </header>
  );
}

export default HeaderBlock;
